module.exports = __webpack_public_path__ + "img/img20.01b01aa8.png";